import { memo } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { Icons, IconType } from '../../../../constants/icons';

import './TTSEnhancementTemplate.css';

export const TTSEnhancementTemplate = memo(() => {
  const { t } = useTranslation();
  return (
    <div className="tts-enhancement">
      <div className="spacer" />
      <div className="container">
        <img className="banner" src={Icons[IconType.TTSBanner]} />

        <h1 className="title">
          {t('How to Download and Use Better TTS Voices on iOS')}
        </h1>
        <p>
          {t(
            'Enhance your Text-to-Speech experience by downloading and using high-quality voices on your iOS device. Follow these steps to get started:',
          )}
        </p>
        <h3>{t('Go to Settings Accessibility')}</h3>
        <p>{t('Unlock your iOS device.')}</p>
        <p>
          <Trans i18nKey="Locate and tap the Setting app.">
            2. Locate and tap the
            <span>Settings</span>
            app.
          </Trans>
        </p>
        <p>
          <Trans i18nKey="Tap Accessibility">
            3. Tap
            <span>Accessibility</span>.
          </Trans>
        </p>

        <h4 />

        <img className="screenshot" src={Icons[IconType.TTSPic01]} />
        <h3>{t('Access Voices')}</h3>
        <p>
          <Trans i18nKey="Tap Spoken Content then Voices.">
            1. Tap
            <span>Spoken Content</span>
            then
            <span>Voices</span>.
          </Trans>
        </p>
        <h4 />
        <img className="screenshot" src={Icons[IconType.TTSPic02]} />
        <img className="screenshot" src={Icons[IconType.TTSPic03]} />

        <h3>{t('Select a Voice')}</h3>
        <p>
          {t(
            'Select a language. Then select a voice and dialect for the device to use.',
          )}
        </p>
        <p className="starText">
          {t('Siris voice is not available in our app.')}
        </p>
        <h4 />
        <img className="screenshot" src={Icons[IconType.TTSPic04]} />
        <img className="screenshot" src={Icons[IconType.TTSPic05]} />
        <h3>{t('Download the Enhanced Voice')}</h3>
        <p>{t('Evan is the selected voice in the above example.')}</p>
        <p>{t('If you choose Evan (Enhanced)')}</p>

        <h4 />
        <img className="screenshot" src={Icons[IconType.TTSPic06]} />
        <h3>{t('Test the Voice')}</h3>
        <p>{t('Once you select a voice')}</p>

        <h4 />
        <h3>{t('Troubleshooting')}</h3>
        <p>{t("If the voice doesn't download")}</p>
        <h1 />
      </div>
      <div className="spacer" />
    </div>
  );
});
